<template>
    <div style="background: #363636">
        <v-container>
            <v-row
                align="start"
                justify="center">
                <v-col cols="12" md="6" lg="3" sm="12">
                    <p v-text="$t('aboutus[0]')" class="subtitle font-weight-light" style="color: #A8A7A7"></p>
                    <br>
                    <p v-text="$t('aboutus[1]')" class="caption font-weight-light" style="color: #A8A7A7"></p>
                    <p v-text="$t('aboutus[2]')" class="subtitle font-weight-light" style="color: #A8A7A7"></p>
                    <v-icon color="#A8A7A7">mdi-facebook</v-icon>
                    <v-icon color="#A8A7A7">mdi-instagram</v-icon>
                    <v-icon color="#A8A7A7">mdi-youtube</v-icon>
                </v-col>

                 <v-col cols="12" md="6" lg="3" sm="12">
                    <p v-text="$t('aboutus[3]')" class="subtitle font-weight-light mt-0" style="color: #A8A7A7"></p>
                    <br>
                    <p class="caption font-weight-light ma-0" style="color: #A8A7A7">Campamento Astronómico</p>
                    <p class="caption font-weight-light ma-0" style="color: #A8A7A7">Privacy Policy</p>
                    <p class="caption font-weight-light ma-0" style="color: #A8A7A7">Registers </p>
                    <p class="caption font-weight-light ma-0" style="color: #A8A7A7">Terms and Conditions</p>
                    <p class="caption font-weight-light ma-0" style="color: #A8A7A7">¡Reserva Exitosa!</p>
                </v-col>

                 <v-col cols="12" md="6" sm="12" lg="3">
                    <p v-text="$t('aboutus[4]')" class="subtitle font-weight-light mt-0" style="color: #A8A7A7"></p>
                    <br>
                    <p class="caption font-weight-light ma-0" style="color: #A8A7A7">blog</p>
                    <p class="caption font-weight-light ma-0" style="color: #A8A7A7">Campamento Astronómico</p>
                    <p class="caption font-weight-light ma-0" style="color: #A8A7A7">Forums</p>
                    <p class="caption font-weight-light ma-0" style="color: #A8A7A7">Registers</p>
                    <p class="caption font-weight-light ma-0" style="color: #A8A7A7">¡Reserva Exitosa!</p>
                </v-col>

                 <v-col cols="12" md="6" sm="12" lg="3">
                    <p v-text="$t('aboutus[5]')" class="subtitle font-weight-light mt-0" style="color: #A8A7A7"></p>
                    <br>
                    <p class="caption font-weight-light ma-0" style="color: #A8A7A7">
                        <v-icon small color="#A8A7A7">mdi-home</v-icon>
                        Ruta Antakari #445, Vicuña, Chile
                    </p>
                    <p class="caption font-weight-light ma-0" style="color: #A8A7A7">
                        <v-icon small color="#A8A7A7">mdi-mail</v-icon>
                        contact@evascopes.com
                    </p>
                    <p class="caption font-weight-light ma-0" style="color: #A8A7A7">
                        <v-icon small color="#A8A7A7">mdi-whatsapp</v-icon>
                        +56 984833668
                    </p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    props:[
        'aboutus'
    ]
}
</script>